import React, { useEffect } from 'react';
import {
    changeNameP1T3,
    changeCredentialsP1T3,
    changeTitle1P1T3,
    changeDepartment1,
    changePhoneP1T3,
    changeClinicP1T3,
    changeFaxP1T3,
    changeAddress,
    changeCity,
    changeState,
    changeZip,
    changeEmailP1T3,
    changeOpen1P1T3,
} from './../CanvasActions';
import TextField from './../Form/TextField';
import SelectField from './../Form/SelectField';

const FormP1T1 = React.memo((props) => {
    useEffect(() => {
        changeNameP1T3(props.name);
    }, [props.name]);

    useEffect(() => {
        changeCredentialsP1T3(props.credentials);
    }, [props.credentials]);

    useEffect(() => {
        changeTitle1P1T3(props.title1);
    }, [props.title1]);

    useEffect(() => {
        changeDepartment1(props.department1);
    }, [props.department1]);

    useEffect(() => {
        changePhoneP1T3(props.phone);
    }, [props.phone]);

    useEffect(() => {
        changeClinicP1T3(props.clinic);
    }, [props.clinic]);

    useEffect(() => {
        changeFaxP1T3(props.fax);
    }, [props.fax]);

    useEffect(() => {
        changeAddress(props.address);
    }, [props.address]);

    useEffect(() => {
        changeCity(props.city);
    }, [props.city]);

    useEffect(() => {
        changeState(props.state);
    }, [props.state]);

    useEffect(() => {
        changeZip(props.zip);
    }, [props.zip]);

    useEffect(() => {
        changeEmailP1T3(props.email);
    }, [props.email]);

    useEffect(() => {
        changeOpen1P1T3(props.open1);
    }, [props.open1]);

    return (
        <form action="">
            <hr />
            <TextField
                required
                label="Name"
                value={props.name}
                setFunction={props.setName}
            />
            <TextField
                label="Credentials"
                value={props.credentials}
                setFunction={props.setCredentials}
            />
            <TextField
                required
                label="Title 1"
                value={props.title1}
                setFunction={props.setTitle1}
                placeholder="Primary title (employee or faculty position)"
            />
            <hr />
            <TextField
                label="Department 1"
                value={props.department1}
                setFunction={props.setDepartment1}
                placeholder="Department/Division/Center Name"
            />
            <hr />
            <TextField
                required
                isPhone
                label="Main"
                value={props.phone}
                setFunction={props.setPhone}
                placeholder="Main Phone"
            />
            <TextField
                required
                isPhone
                label="Direct"
                value={props.clinic}
                setFunction={props.setClinic}
                placeholder="Direct Phone"
            />
            <TextField
                isPhone
                label="Fax"
                value={props.fax}
                setFunction={props.setFax}
                placeholder="Contact Fax"
            />
            <hr />
            <TextField
                required
                label="Address"
                value={props.address}
                setFunction={props.setAddress}
            />
            <TextField
                required
                label="City"
                value={props.city}
                setFunction={props.setCity}
            />
            <TextField
                required
                label="State"
                value={props.state}
                setFunction={props.setState}
            />
            <TextField
                required
                label="Zip"
                value={props.zip}
                setFunction={props.setZip}
            />
            <hr />
            <TextField
                required
                label="Email"
                value={props.email}
                setFunction={props.setEmail}
                placeholder="Email address"
            />
            <TextField
                label="Website"
                value={props.open1}
                setFunction={props.setOpen1}
            />
            <hr />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: '250', label: '250' },
                    { value: '500', label: '500' },
                    { value: '1000', label: '1000' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> UT Physicians</div>
                <div className="description-list">
                    <span className="label">Description:</span>
                    <ul>
                        <li>Variables one side</li>
                        <li>Size 3.5x2</li>
                        <li>One sided </li>
                        <li>Color one side</li>
                        <li>#80 Avalanche Smooth Cover</li>
                    </ul>
                </div>
            </div>
        </form>
    );
});

FormP1T1.propTypes = {

}

export default FormP1T1;
